import {Component, EventEmitter, ViewContainerRef} from '@angular/core';
import {Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Configuration} from '../../shared/services/configuration';
import {HttpClientCustom} from '../../shared/services/http.client';
import * as _ from 'underscore';
import {Location} from '@angular/common';
import {SharedData} from '../../shared/sharedData';
import {ToasterComponent} from '../../toasterComponent/toasterComponent';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'addUsersToGroup',
    templateUrl: 'addUsersToGroup.html'
})
export class AddUsersToGroupComponent {
    public _baseUrl: any;
    public selectedOption: any = 'everyone';
    public deleteEmpCodes: any = [];
    public groupId: any;
    public empCodes: any = '';
    public invalidEmployeeCodes: any = [];
    public disableButton: any = false;
    public type = "";
    public disabledButton: any = false;
    selectedAll: any;
    //pagination variables  and default values
    public pageSize: any = 10;
    public page = 1;
    public startingPage: any = 1;
    public endingPage: any = 10;
    public collectionSize: any;
    public searchData = {
        "nameOrCodeOrEmail": "",
        "employeeCodes": [],
        "excludedEmployeeCodes": [],
        "includeEmpIds": [],
        "excludeEmpIds": [],
        "gradeIds": [],
        "mgrLevelIds": [],
        "designationIds": [],
        "categoryIds": [],
        "includeOrgIds": [],
        "excludeOrgIds": [],
        "supervisorIds": [],
        "primarySupervisorIds": [],
        "primarySupervisorNameOrCode": null,
        "primarySupervisorCods": [],
        "employeeStatus": null,
        "employeesWithOutSupervisor": null,
        "scorecardStates": null,
        "memberShipState": null,
        "programId": null,
        "pageSize": 10,
        "page": 1,
        "fetchSupervisorLevels": 0
    }

    public allSelectedEmplUserIds: any = [];
    public employeeData: any = [];
    public employeePageData: any = {};
    public id: any;

    public updateRate: any = new EventEmitter();
    public asl: boolean = false;
    public showChild: boolean = false;
    public localState = { value: '' };
    public orgData: any = [];
    public trackHides = null;
    public designationModel: any;
    public organizationModel: any;
    public primarySupervisorModel: any;
    public employeeCode: any;
    public showAdvanceSearch: any = false;
    public showLoading: any = false;

    constructor(
        public _global: Configuration,
        public http: HttpClientCustom, public router: Router,
        public _toaster: ToasterComponent,
        public modalService: NgbModal,
        public activeModal: NgbActiveModal,
        public share: SharedData,
        public _location: Location,
        public translate:TranslateService,

        vcr: ViewContainerRef) {
        this._baseUrl = _global.get("EPMS_BASE_URL");
        let data: any = this.share.getData();
        if (_.isEmpty(data)) {
            this._location.back();
        } else {
            this.type = data.type;
            this.groupId = data.userGroup;
            if (this.type == "DELETEUSERS") {
                this.getEmployeeDetails();
            }

            this._toaster.setViewRef(vcr);
        }
    }

    rolesBack() {
        this._location.back();
    }


    showAdvanced() {
        this.share.saveAsMap('UserGroup',  this.groupId);
        this.router.navigate(['menu/employeeSearch']);
    }

    getEmployeeDetails() {
        try {
            let that = this;
            let url = that._baseUrl + 'v1/hub/userGroup/getEmployeeInfoByGroupId/' + that.groupId;
            that.http.post(url, this.searchData).subscribe((result) => {
                that.selectedAll = false;
                that.disabledButton = false;
                that.employeeData = result.content;
                that.employeePageData = result;
                that.allSelectedEmplUserIds.length = 0;
                if (that.employeeData.length == 0) {
                    that.showLoading = false;
                }

                that.collectionSize = result.totalElements;
                if (result.last) {
                    that.endingPage = that.collectionSize;
                }
            });
        } catch (e) {
            console.log('error', e);
        }
    }


    removeUsers() {
        this.invalidEmployeeCodes = [];
        this.deleteEmpCodes=[];

        if (this.validateEmpCodes()) {
            this.finalRemoveUsers();
        }

    }
    

    addUsers() {
        this.invalidEmployeeCodes = [];
        if (this.selectedOption == 'everyone') {
            this.finalAddUsers('assignGroupToAllEmployees');
        }
        if (this.selectedOption == 'except') {
            this.searchData.excludedEmployeeCodes=[];
            if (this.validateEmpCodes()) {
                this.finalAddUsers('assignGroupExcludeEmployeeCodes');
            }
        }
        if (this.selectedOption == 'everyoneIn') {
            this.searchData.employeeCodes=[];
            if (this.validateEmpCodes()) {
                this.finalAddUsers('assignGroupIncludeEmployeeCodes');
            }

        }
    }

    OnPageSizeChanged(val) {
        this.pageSize = val;
        this.onPageChange(1);
    }

    public clicked() {
    }
    public onPageChange(event: number): void {
        if (event == 1) {
            this.startingPage = 0;
            if (this.employeeData.length > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = this.employeeData.length;
            }
        } else {
            this.startingPage = 0 + ((event - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((event - 1) * +this.pageSize);
            if (this.endingPage > this.employeeData.length) {
                this.endingPage = this.employeeData.length;
            }
        }
    }
    finalRemoveUsers() {
        let that = this;

        
        that.disableButton = true;
        let url = that._baseUrl + 'v1/hub/userGroup/removeGroupUsers/' + that.groupId;
        that.http.post(url, that.deleteEmpCodes).subscribe((result) => {
            that.disableButton = false;
            if (result.success) {
                this.translate.get('userRemoved').subscribe((msg)=>{
                    that._toaster.showSuccess(msg);
                });
                setTimeout(() => { that.rolesBack() }, 1000);
            } else {
                this.translate.get(result.errorMessages[0]).subscribe((msg)=>{
                    that._toaster.showError(msg);
                })
                
            }
        });
    }

    finalAddUsers(option) {
        let that = this;
        let flag = false;
        
        that.disableButton = true;
        let url = that._baseUrl + 'v1/hub/userGroup/' + option + '/' + that.groupId;
        that.http.post(url, that.searchData).subscribe((result) => {
            that.disableButton = false;
            if (option == 'assignGroupToAllEmployees') {
                if (result) {
                    flag = true;
                }
            } else {
                if (result.status) {
                    flag = true;
                }
            }
            if (flag) {
                this.translate.get('usersAdded').subscribe((msg)=>{
                    that._toaster.showSuccess(msg);
                });
               
                setTimeout(() => { that.rolesBack() }, 1000);
            } else {
                this.translate.get(result.errorMessages[0]).subscribe((msg)=>{
                    that._toaster.showError(msg);
                })
                
                if (result.invalidEmployeeCodes.length > 0) {
                    that.getInvalidEmpCode(result.invalidEmployeeCodes);
                }
            }
        });
    }
    validateEmpCodes() {
        let that = this;
        if (that.empCodes.trim() == '' || that.empCodes.length == 0) {
            this.translate.get('pleaseEnterEmpToContinue').subscribe((msg)=>{
                that._toaster.showError(msg);
            });
            
            return false;
        } else {
            let empCode = that.empCodes.split(',');
            _.each(empCode, function (key, val) {
                if (that.selectedOption == 'everyoneIn') {
                    that.searchData.employeeCodes.push(key.trim());
                }
                 if (that.selectedOption == 'except') {
                    that.searchData.excludedEmployeeCodes.push(key.trim());
                }
                if(that.selectedOption == 'everyone')
                {
                    that.deleteEmpCodes.push(key.trim());
                }
            });
        }
        return true;
    }
    getInvalidEmpCode(invalidEmployeeCodes) {
        let that = this;
        _.each(invalidEmployeeCodes, function (val, key) {
            that.invalidEmployeeCodes.push(val);
        });
    }


    selectOption(option) {
        
        this.selectedOption = option;
        this.invalidEmployeeCodes=[];
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/userGroup/addUsersToGroup.ts